import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Technologygcc = () => {
  return (
    <div className="tabing_section healthcare_tabs_sec p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={10}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Tech Stack that Powers Our <span>Construction Software</span>{" "}
              Development
            </h2>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Development Tools">
              <ul>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/construction-software/development-tools/Android_Studio.webp"
                    alt="Android Studio"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Android Studio</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/construction-software/development-tools/Net_beans.webp"
                    alt="Netbeans"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Netbeans</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/construction-software/development-tools/Visual_Studio.webp"
                    alt="Visual Studio"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Visual Studio</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/construction-software/development-tools/Zend_Studio.webp"
                    alt="Zend Studio"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Zend Studio</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Design Tools">
              <ul>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/construction-software/design-tools/Figma.webp"
                    alt="Figma"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Figma</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/construction-software/design-tools/Photoshop.webp"
                    alt="Photoshop"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Photoshop</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/construction-software/design-tools/Sketch.webp"
                    alt="Sketch"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Sketch</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/construction-software/design-tools/adobe-xd.webp"
                    alt="Adobe Xd"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Adobe Xd</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Languages">
              <ul>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/construction-software/frontend/AngularJs.webp"
                    alt="AngularJs"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>AngularJs</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/construction-software/frontend/CSS.webp"
                    alt="CSS"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>CSS</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/construction-software/frontend/HTML.webp"
                    alt="HTML"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>HTML</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/construction-software/frontend/JS.webp"
                    alt="JS"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Javascript</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Testing Tools">
              <ul>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/construction-software/testing-tools/Codeception.webp"
                    alt="Codeception"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div class="text_tabs_web">
                    <h6>Codeception</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/construction-software/testing-tools/PHP_Unit.webp"
                    alt="PHP_Unit"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div class="text_tabs_web">
                    <h6>PHP Unit</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/construction-software/testing-tools/Selenium_HQ.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div class="text_tabs_web">
                    <h6>SeleniumHQ</h6>
                  </div>
                </li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
